module.exports = __webpack_public_path__ + "img/summary-download.37086519.png";